// extracted by mini-css-extract-plugin
module.exports = {"hidden":"feedback_hidden__MqMTc","textEmphasis":"feedback_textEmphasis__4Yf0c","feedbackArea":"feedback_feedbackArea__aszNT","feedbackInner":"feedback_feedbackInner__uW_Va"};